export default __webpack_public_path__ + "static/5-d106e6feb75c70621339fa8a062a6543.jpg";